var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout page"},[_c('Header'),_c('div',{ref:"scrollContainer",staticClass:"main-view-container",class:{ noScroll: !_vm.isNotHome },attrs:{"data-scroll-container":""}},[_c('router-view'),(_vm.isNotHome)?_c('Footer'):_vm._e()],1),(!_vm.isNotHome)?_c('home-footer'):_vm._e(),(!_vm.isMobile)?_c('mouse'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }